<template>
  <div>
    <v-dialog max-width="560px" persistent v-model="isOpen">
      <v-card>
        <v-card-title>Repair</v-card-title>
        <v-form
          ref="formPORepair"
          data-vv-scope="formEditPORepair"
          lazy-validation
        >
          <v-card-text class="pt-0">
            <v-container grid-list-md class="pb-0">
              <v-layout wrap>
                <v-flex xs12>
                  <v-checkbox
                    label="Repair request"
                    required
                    v-model="formData.repair_request"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 v-show="formData.repair_request">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-menu
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="formData.repair_date"
                        full-width
                        lazy
                        min-width="290px"
                        offset-y
                        ref="datePicker"
                        transition="scale-transition"
                        v-model="isDatePickerOpen"
                      >
                        <v-text-field
                          label="Repair Date"
                          prepend-icon="event"
                          readonly
                          clearable
                          slot="activator"
                          v-model="formData.repair_date"
                          :rules="[rules.required]"
                          required
                        ></v-text-field>
                        <v-date-picker
                          no-title
                          scrollable
                          :allowed-dates="allowedDates"
                          v-model="formData.repair_date"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="isDatePickerOpen = false"
                            color="primary"
                            flat
                            >Cancel</v-btn
                          >
                          <v-btn
                            @click="$refs.datePicker.save(formData.repair_date)"
                            color="primary"
                            flat
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12>
                      <v-autocomplete
                        label="Select user assign"
                        multiple
                        small-chips
                        hide-no-data
                        :loading="loadingSelectUser"
                        :items="userList"
                        :search-input.sync="userQuery"
                        v-model="formData.assign_users"
                        :rules="[rules.autocompleteField]"
                        required
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogConfirm = true">Cancel</v-btn>
            <v-btn @click="save" color="primary">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog max-width="450px" persistent v-model="dialogStatus">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogStatus = false" style="width: 85px">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="450px" persistent v-model="dialogConfirm">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>Are you sure to cancel the changes?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
          <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { startOfDay } from "date-fns";
import PurchaseOrderService from "../services/purchase.order.service.js";

export default {
  inject: ["$validator"],
  model: {
    prop: "open",
    event: "toggle",
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    poId: {
      type: String,
      required: true,
    },
    loadingSelectUser: {
      type: Boolean,
      default: false,
    },
    userList: {
      validator: function (list) {
        return (
          Array.isArray(list) &&
          list.every(
            (item) =>
              typeof item.text === "string" && typeof item.value === "string"
          )
        );
      },
    },
  },
  data() {
    return {
      purchaseOrderService: new PurchaseOrderService(),
      isOpen: false,
      isDatePickerOpen: false,
      dialogStatus: false,
      dialogConfirm: false,
      errorMessage: "",
      userQuery: "",
      formData: {
        repair_request: false,
        repair_date: "",
        assign_users: [],
      },
      rules: {
        required: (v) => !!v || "It is required field",
        autocompleteField: (v) => !!v.length || "It is required field",
      },
    };
  },
  methods: {
    allowedDates(date) {
      // Disable past dates
      const today = new Date();
      return startOfDay(date) >= startOfDay(today);
    },
    fetchData() {
      this.purchaseOrderService.getRepairDetail(this.poId).then((res) => {
        this.formData = {
          repair_request: res.data.repair_request || false,
          assign_users: (res.data.assign_users || []).map((u) => u.id),
          repair_date: res.data.repair_date
            ? this.$morphDate(res.data.repair_date, "YYYY-MM-DD")
            : "",
        };
        this.$nextTick(() => {
          this.isOpen = true;
        });
      });
    },
    save() {
      if (this.formData.repair_request) {
        this.$validator.validate("formEditPORepair.*").then((result) => {
          if (result && this.$refs.formPORepair.validate()) {
            this.editRepairDetail();
          }
        });
      } else {
        this.editRepairDetail();
      }
    },
    editRepairDetail() {
      const data = {
        ...this.formData,
        repair_date: this.formData.repair_date
          ? this.$morphDate(
              this.formData.repair_date,
              "YYYY-MM-DD[T00:00:00.000Z]"
            )
          : null,
      };
      this.purchaseOrderService
        .editRepairDetail(this.poId, data)
        .then((res) => {
          if (res.data && res.data.statusCode === 200) {
            this.close();
          } else {
            this.dialogStatus = true;
            this.errorMessage = res.data.message;
          }
        });
    },
    close() {
      this.$emit("toggle", false);
    },
  },
  watch: {
    open(value) {
      if (value) {
        this.fetchData();
      } else {
        this.$refs.formPORepair.reset();
        this.$refs.formPORepair.resetValidation();
        this.isOpen = false;
        this.dialogConfirm = false;
      }
    },
    userQuery: {
      handler(query) {
        this.$emit("user-query", query);
      },
      immediate: false,
    },
    "formData.repair_request": {
      handler(value) {
        this.$refs.formPORepair.resetValidation();
        this.formData.repair_request = value;
        if (!value) {
          this.formData.repair_date = null;
        }
      },
      deep: true,
    },
  },
};
</script>
